import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CardSizeStore } from '~/classes/CardSizeStore';
import { useCardSizePreference } from '~/hooks/useCardSizePreference';
import { useRouterSelector } from '~/hooks/useRouterSelector';
import { setCardSizeAction, setSavedConfigurableViewsAction } from '~/store/configViews/actions';
import { currentConfigurableViewSelector, savedConfigurableViewsSelector } from '~/store/configViews/selectors';

export const usePublicShowcaseCardSizeSync = () => {
  const dispatch = useDispatch();
  const { cardSize } = useCardSizePreference();
  const savedConfigurableViews = useSelector(savedConfigurableViewsSelector);
  const currentConfigurableView = useSelector(currentConfigurableViewSelector);
  const pathname = useRouterSelector((location) => location.pathname);

  useEffect(() => {
    if (!pathname || !currentConfigurableView) return;

    const cardSizeStore = CardSizeStore.getInstance();

    const initialCardSize = cardSizeStore.getCardSize(pathname);
    if (initialCardSize !== currentConfigurableView.cardSize) {
      dispatch(setCardSizeAction({ cardSize: initialCardSize }));
    }

    const unsubscribe = cardSizeStore.subscribe(pathname, (newCardSize) => {
      dispatch(setCardSizeAction({ cardSize: newCardSize }));
    });

    return unsubscribe;
  }, [pathname, currentConfigurableView, dispatch]);

  useEffect(() => {
    if (savedConfigurableViews.length > 0) {
      const needsUpdate = savedConfigurableViews.some((view) => view.cardSize !== cardSize);
      if (needsUpdate) {
        const viewsWithCardSize = savedConfigurableViews.map((view) => ({
          ...view,
          cardSize,
        }));
        dispatch(
          setSavedConfigurableViewsAction({
            savedConfigurableViews: viewsWithCardSize,
          }),
        );
      }
    }
  }, [cardSize, dispatch, savedConfigurableViews]);
};
